/* eslint-disable react/prop-types */
import React from 'react';
import parse from 'html-react-parser';
import Img from 'gatsby-image';

const Event = ({
  index,
  event: {
    eventDate,
    eventFormat,
    eventLink,
    eventLocation,
    eventName,
    eventTime,
    eventImage,
  },
}) => (
  <div className="event" id={index}>
    <div className="event-image-container">
      {eventImage ? (
        <Img
          fluid={eventImage.localFile.childrenImageSharp[0].fluid}
          alt="event Image"
          className="event-image"
        />
      ) : (
        ''
      )}
      {eventFormat ? (
        <div className="event-type">
          <p>{eventFormat}</p>
        </div>
      ) : (
        ''
      )}
    </div>
    <div className="event-deck">
      {eventName ? (
        <h4>
          {eventLink ? (
            <a target="_blank" href={eventLink} rel="noreferrer">
              {parse(eventName)}
            </a>
          ) : (
            <>{parse(eventName)}</>
          )}
        </h4>
      ) : (
        ''
      )}
      {eventLocation ? <h5>{eventLocation}</h5> : ''}
      <p>
        {eventDate ? <span>{eventDate}</span> : ''} -{' '}
        {eventTime ? <span>{eventTime}</span> : ''}
      </p>
      {eventLink ? (
        <a className="event-cta" target="_blank" href={eventLink} rel="noreferrer">
          View Event
        </a>
      ) : (
        ''
      )}
    </div>
  </div>
);

export default Event;
